import React, { ReactNode } from 'react';
import { Row, Col } from 'react-bootstrap';

interface ColProps {
  childrenLeft?: ReactNode;
  childrenRight?: ReactNode;
  className?: string;
}

const InfoRow: React.FC<ColProps> = ({ childrenLeft, childrenRight, className }) => {
  return (
    <Row className={`justify-content-center ${className}`}>
      <Col sm={2} xs={4}>
        {childrenLeft}
      </Col>
      <Col sm={4} xs={6}>
        {childrenRight}
      </Col>
    </Row>
  );
};

export default InfoRow;
